<template>
  <div class="content">
    <div class="info-button" :class="openPanel ? 'opened' : ''" @click="toggleOpenPanel">
      <InfoIcon :size="27" class="info-icon" />
    </div>
    <div @click="toggleOpenPanel" class="transparent-exit" :class="openPanel ? 'opened' : ''"></div>

    <div class="info-wrapper yellow-scroll" ref="container" :style="{ top: `${top + topUnity}` }" :class="openPanel ? 'opened' : ''">
      <div class="header" ref="target">
        <ChevronDoubleDown :size="30" @click="toggleOpenPanel()" />
      </div>
      <div class="container yellow-scroll">
        <div class="fixed-panel fixed-panel-left">
          <div class="bloc-left shadow-s">
            <user-info-tile
              :user="user"
              :stats="userStats"
            />
          </div>
          <HowToTile />
          <IntranetPresentationTile />
        </div>

        <div class="fixed-panel fixed-panel-right">
          <div class="bloc-right shadow-s">
            <communities-infos :communities-infos="this.communitiesInfos" />
          </div>
          <suggested-communities v-if="suggestedCommunities.length > 0"
                                 :communities="suggestedCommunities"
          />
          <ReadAboutTile />
        </div>
      </div>
    </div>
    <div class="posts" id="homepage">
      <post-create :community-list="userCommunities" :multiple-community-choice="true" />
      <sorting-menu
        type="posts"
        v-if="posts.length !== 0 || currentSort === 'popularity'"
      />
      <div v-if="posts">
        <div
          v-for="post in posts"
          :key="post.id"
        >
          <div v-if="post.type === 'post'">
            <Post :post="post" />
          </div>
          <div v-else-if="post && post.type === 'welcome'">
            <welcome-post
              :post="post"
              :show-community="true"
            />
          </div>
        </div>
      </div>
      <!--Configure messages: https://peachscript.github.io/vue-infinite-loading/guide/configure-load-msg.html#via-plugin-api-->
      <infinite-loading
        v-if="this.$store.getters.postsSort === 'chronology'"
        :identifier="uniqueId"
        @infinite="loadMorePosts"
      >
        <div slot="no-more" />
        <div
          slot="no-results"
          v-if="posts.length === 0"
        >
          <div v-if="currentFilter() === 'myCommunities'">
            {{ $t('home.homePage.noPostsInCommunities') }}
          </div>
          <div v-if="currentFilter() === 'myPublished'">
            {{ $t('home.homePage.noPublishedPost') }}
          </div>
          <div v-if="currentFilter() === 'myBookmarks'">
            {{ $t('home.homePage.noBookmarkedPost') }}
          </div>
          <logo-background />
        </div>
        <div slot="no-results" />
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import Post from '@/components/post/Post'
import WelcomePost from '@/components/post/WelcomePost'
import InfiniteLoading from 'vue-infinite-loading'
import PostCreate from '@/components/post/PostCreate'
import CommunitiesInfos from '@/components/home/CommunitiesInfos'
import UserInfoTile from '@/components/user/UserInfoTile'
import LogoBackground from '@/components/shared/LogoBackground'
import SortingMenu from '@/components/shared/SortingMenu'
import ReadAboutTile from '@/components/shared/ReadAboutTile'
import SuggestedCommunities from '@/components/shared/SuggestedCommunities'
import { mapState } from 'vuex'
import HowToTile from '../shared/HowToTile'
import IntranetPresentationTile from '../shared/IntranetPresentationTile'
import InfoIcon from 'vue-material-design-icons/InformationOutline.vue'
import swipe from '@/components/post/Swipe'
import ChevronDoubleDown from 'vue-material-design-icons/ChevronDoubleDown.vue'
import { ref } from 'vue'

const top = ref(100)
const topUnity = ref('vh')

export default {
  name: 'HomePage',
  components: {
    ChevronDoubleDown,
    HowToTile,
    IntranetPresentationTile,
    ReadAboutTile,
    Post,
    InfiniteLoading,
    PostCreate,
    CommunitiesInfos,
    UserInfoTile,
    LogoBackground,
    SortingMenu,
    SuggestedCommunities,
    WelcomePost,
    InfoIcon
  },
  data() {
    return {
      suggestedCommunities: [],
      currentYPosition: 0,
      openPanel: false,
      top: top,
      topUnity: topUnity
    }
  },
  beforeMount() {
    top.value = 100
    topUnity.value = 'vh'
  },
  mounted() {
    swipe.setSwipe(top,
      this.toggleOpenPanel,
      this.$refs['target'], this.$refs['container'],
      200,
      0)
  },
  async created() {
    // force await so we are sure that 'fetchPosts' is using the correct postFilter
    await this.$store.dispatch('setPostFilter', 'myCommunities')
    this.$store.dispatch('fetchPosts')
    this.$store.dispatch('fetchCommunitiesInfo')
    this.$store.dispatch('fetchUserStats')
    this.suggestedCommunities = await this.$store.dispatch('suggestedCommunities')
    window.addEventListener('scroll', this.logit)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.logit)
    document.body.classList.remove('noscroll')
  },
  methods: {
    async loadMorePosts ($state) {
      await this.$store.dispatch('fetchPosts')
      if (this.$store.getters.cursors.hasNext) {
        $state.loaded()
      } else {
        $state.complete()
      }
    },
    toggleOpenPanel() {
      if (!this.openPanel) {
        top.value = 200
        topUnity.value = 'px'
        document.body.classList.toggle('noscroll', true)
      } else {
        top.value = 100
        topUnity.value = 'vh'
        document.body.classList.remove('noscroll', true)
      }
      this.openPanel = !this.openPanel
    },
    currentFilter () {
      return this.$store.getters.postsFilter
    },
    logit() {
      if (window.pageYOffset > window.innerHeight && this.currentYPosition < window.innerHeight) {
        this.currentYPosition = window.pageYOffset
        this.$store.dispatch('triggerScroll', window.location.pathname)
      }
    }
  },
  computed: {
    posts () {
      return this.$store.getters.filteredPosts
    },
    uniqueId () {
      // Unique identifier for infinite loading, reset state because we changed filters
      return this.$store.getters.postsFilter + new Date()
    },
    communitiesInfos () {
      return this.$store.getters.communitiesInfos
    },
    currentSort () {
      return this.$store.getters.postsSort
    },
    ...mapState({
      user: state => state.user.user,
      userStats: state => state.user.userStats,
      userCommunities: state => state.user.userCommunities
        .filter(userCommunity => userCommunity.isAllowedToPost)
        .map(userCommunity => userCommunity.community)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.content{
  display: grid;
  place-content: center;
  width: 100vw;
}
#homepage {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  min-height: auto;

  @media (max-width: $medium) {
    max-width: 50vw;
  }

  @media (max-width: $header-change) {
    max-width: none;
  }
}

.fixed-panel {
  position: fixed;
}

.absolute-panel {
  position: absolute;
}

.left-margin {
  margin-left: 1rem;
}

.posts {
  display: flex;
  flex-direction: column;
  width: 50vw;
  max-width: 638px;
  min-height: 80vh;

  @media (max-width: $medium) {
    left: 25vw;
    max-width: none;
  }

  @media (max-width: $header-change) {
    left: auto;
    width: 80vw;
    margin: 0 0 70px 0 !important;
  }

  @media (max-width: $small) {
    width: 100vw;
    transition: all 0.2s ease;

  }
}

.lined-block {
  background: #FFFFFF;
  box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.20);
  border-radius: 3px;
  width: 606px;
  margin: 1rem;
  border-top: solid 2px $secondary-color;
  text-align: left;
  color: $black-color;
  letter-spacing: 0;
  line-height: 24px;
}

.bloc-left {
  width: 220px;
  background-color: rgba(255,255,255,0.4);

  border-top: solid 2px $secondary-color;
  margin: 0 0 1rem 0;

  @media (max-width: $header-change) {
    background-color: white;
  }
}

.bloc-right {
  width: 220px;
  background-color: white;
  background-color: rgba(255,255,255,0.4);
  border-top: solid 2px $secondary-color;
  //box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.20);

  margin-bottom: 1rem;

  & > * + * {
    border-top: solid 1px #D8D8D8;
  }
}

.suggested {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;

  .title-bloc {
    margin: 1rem;
  }

  .community {
    display: flex;
    flex-direction: row;
    margin: 0.5rem 0 0.5rem 1.2rem;
    justify-content: flex-start;
    align-items: center;
    text-align: left;

    img {
      width: 112px;
      height: 63px;
    }

    .name {
      margin-left: 0.8rem;
      width: 79px;
      color: $primary-color;
    }
  }
}

.panel {
  @media (max-width: $medium) {
    max-width: calc(25vw - 16px);
  }
}
</style>
<style scoped src="@/sass/info-responsive.scss" lang="scss"/>
